<bb-switch-ui
  [labelPosition]="'right'"
  [label]="'Show notifications'"
  formControlName="notifications"
>
</bb-switch-ui>
